"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// THEO error.cause. This isn't a documented field, but it's value is a constant.
var MANIFEST_CORS_ERROR_CAUSE = 'MFL3900';
// THEO error.message. Documented field, but value is able to be localized (though we don't).
var MANIFEST_CORS_ERROR_MESSAGE = 'Could not load the manifest file. Make sure the source is set correctly and that CORS support is enabled.';
function isManifestCorsError(err) {
  return err && (err.cause === MANIFEST_CORS_ERROR_CAUSE || err.message === MANIFEST_CORS_ERROR_MESSAGE) || false;
}
var _default = exports["default"] = {
  isManifestCorsError: isManifestCorsError
};